import axios from './_axios_config';
import { request } from './_process_request';

export const ct_users = {
    async signIn({ email, password, keepLogged = false }) {
        return request(axios.post('/auth/signin', { email, password, keep_logged: keepLogged }));
    },

    async signUp(data) {
        return request(axios.post('/auth/signup', data));
    },

    async logout() {
        return request(axios.post('/auth/logout'));
    },

    async forgotPassword({ email }) {
        return request(axios.post('/auth/forgot-password', { email }));
    },

    async resetPassword({ token, password }) {
        return request(axios.post('/auth/reset-password', { token, password }));
    },

    async getAccount(access_token) {
        const headers = access_token ? { Authorization: `Bearer ${access_token}` } : {};
        return request(axios.get('/account', { headers }));
    },

    async updateAccount(data) {
        return request(axios.put('/account', data));
    },

    async changePassword({ current_password, new_password }) {
        return request(axios.put('/account/password', { current_password, new_password }));
    },
};
